import React, { useState, useEffect } from "react";

function CountDown({ Min, Sec, onTimeout }) {
    const [seconds, setSeconds] = useState(Sec);
    const [minutes, setMinutes] = useState(Min);

    function updateTime() {
        if (minutes === 0 && seconds === 0) {
            onTimeout(true);
        } else if (seconds === 0) {
            setMinutes((minutes) => minutes - 1);
            setSeconds(59);
        } else {
            setSeconds((seconds) => seconds - 1);
        }
    }
    useEffect(() => {
        const token = setTimeout(updateTime, 1000);
        return function cleanUp() {
            clearTimeout(token);
        };
    });
    return (
        <div>
            {/* {minutes === 0 && seconds === 0 ? (
                "مجددا درخواست نمایید"
            ) : ( */}
            <h6 className="h6-head center checkoutTime__txt">
                {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
            </h6>
            {/* )} */}
        </div>
    );
}

export default CountDown;
